import { useCallback, useLayoutEffect, useState } from "react";

export const useIFrameDocument = (
  iframeId: string,
  dependencyPath?: string,
) => {
  const [iFrameDocument, setIFrameDocument] = useState<Document | null>(null);

  const getIFrameDocument = useCallback(() => {
    const iframeElement = document.getElementById(iframeId);
    if (!(iframeElement instanceof HTMLIFrameElement)) {
      return null;
    }

    return iframeElement.contentDocument;
  }, [iframeId]);

  useLayoutEffect(() => {
    const document = getIFrameDocument();
    if (!document) {
      return;
    }

    setIFrameDocument(document);
  }, [getIFrameDocument, dependencyPath]);

  return iFrameDocument;
};
